function state() {
	return {
		isOpen: null,
		baseUrl: null
	};
}

const mutations = {
	open(state, payload) {
		state.isOpen = payload.menu;
	},
	close(state) {
		state.isOpen = null;
	},
	setBaseUrl(state, payload) {
		state.baseUrl = payload.baseUrl;
	}
};

export default {
	state,
	mutations
};
